import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { MenuItem } from '@/types'
import { can } from '@/ability'
import { computed, ComputedRef } from '@vue/composition-api'


// TODO: Can we expand this so we can also use it for the regular CasterStatus menu (which has more items
//       and conditions)
const useCasterStatusMenu = (isCasting: ComputedRef<boolean>) => {
  const canModifyCaster = computed(() => can.value(AbilityAction.Edit, AbilitySubject.Cast))
  const menuItems = computed(() => {
    const items: MenuItem[] = []

    if (canModifyCaster.value) {
      items.push({ label: 'Caster Info', action: 'casterInfo', icon: 'info-circle' })
      if (can.value(AbilityAction.Edit, AbilitySubject.Members)) {
        items.push({ label: 'Edit Profile', action: 'edit', icon: 'user-edit' })
      }
      if (isCasting.value) {
        items.push({ label: 'Restart Stream', action: 'restart', icon: 'sync-alt' })
      }
      items.push({ label: 'Remove Caster', action: 'remove', icon: 'trash' })
    }
    return items
  })

  return {
    menuItems
  }
}

export default useCasterStatusMenu
